import {ResourceAllocationState, Team} from '../../../types';
import {removeTeamCascade} from '../cascadeDelete';

export const teamHandlers = {
    TeamAdded: (
        state: ResourceAllocationState,
        data: Team
    ): ResourceAllocationState => {
        return {
            ...state,
            teams: {...state.teams, [data.id]: data}
        };
    },
    TeamUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<Team>}
    ): ResourceAllocationState => {
        // A scoped /state doesn't hold every team — an update about an unloaded
        // team is irrelevant here, and spreading undefined would fabricate a
        // ghost entity.
        if (!state.teams[data.id]) {
            return state;
        }
        return {
            ...state,
            teams: {
                ...state.teams,
                [data.id]: {
                    ...state.teams[data.id],
                    ...data.updates
                }
            }
        };
    },
    TeamDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        // Mirror the DB cascade: also scrub this team id from every person's teamIds.
        return removeTeamCascade(state, data.id);
    }
};
